import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from "../componentes/header/header";
import Footer from "../componentes/footer/footer";
import { assets } from "../assets/assets";
import './conserto_relogio.css'; // Reutilizando o CSS para manter o padrão
import { abrirOrcamentoWhats, trazerRodapePaginasServicos, trazerTituloServicos } from '../utils/utils';

const ConfeccaoCarimbos = () => {
  const navigate = useNavigate();
  useEffect(() => {
    document.title = "Trinco | Serviços de carimbo";
  }, []);

  return (
    <div className="servico-detalhe-page">
      <Header />

      {/* Hero Banner */}
      <section className="servico-hero" style={{ backgroundImage: `url(${assets.confeccaoCarimbo})` }}>
        <div className="servico-hero-overlay">
          <h1>Serviços de Carimbos</h1>
          <p>Sua marca e sua assinatura em tudo.</p>
        </div>
      </section>

      {/* Conteúdo Explicativo */}
      <main className="conteudo-servico-container">

        <article className="bloco-texto">
          <h2>{trazerTituloServicos('carimbos')}</h2>
        </article>

        {/* Bloco 1: Carimbos Essenciais (4910, 4913) */}
        <section className="sessao-explicativa">
          <div className="texto-lado">
            <h3>Modelos</h3>

            <h4>Carimbo automático</h4>
            <p>Modelo com tinta interna para uso contínuo.</p>

            <h4>Carimbo datador</h4>
            <p>Carimbo com ajuste de datas.</p>

          </div>
          <div className="imagem-lado">
            <img src={assets.carimbosPadrao} alt="Carimbos 4910 e 4913" />
          </div>
        </section>

        {/* Bloco 2: Carimbos Pocket e Troca de Resina */}
        <section className="sessao-explicativa reverse">
          <div className="texto-lado">
            <h3>Manutenção e reposição</h3>

            <h4>Troca de borracha</h4>
            <p>Substituição da parte de gravação para restaurar a qualidade da marcação.</p>

            <h4>Troca de resina</h4>
            <p>Reposição da borracha mantendo a base original.</p>

            <h4>Troca de almofadas</h4>
            <p>Substituição da almofada para manter a marcação precisa.</p>
          </div>
          <div className="imagem-lado">
            <img src={assets.carimboPocketTrocaResina} alt="Carimbo pocket e troca de resina" />
          </div>
        </section>

        {/* Bloco 3: Personalizados e Tintas (Genérico para complementar) */}
        <section className="sessao-explicativa">
          <div className="texto-lado">
            <h3>Personalização</h3>

            <h4>Logotipos e assinaturas</h4>
            <p>Gravação de marcas, nomes e assinaturas.</p>

            <h4>Desenhos e símbolos</h4>
            <p>Aplicação de elementos gráficos sob medida.</p>
          </div>
          <div className="imagem-lado">
            <img src={assets.carimbosPersonalizados} alt="Carimbos personalizados e acessórios" />
          </div>
        </section>

        <div className="fechamento-texto">
          <h4>{trazerRodapePaginasServicos('serviços de carimbos')}</h4>
        </div>

        {/* CTA FINAL */}
        <div className="cta-container-detalhe">
          <button className="btn-orcamento-whats" onClick={() => abrirOrcamentoWhats('serviços de carimbos')}>
            Solicitar orçamento
          </button>
          <button className="btn-voltar-simples" onClick={() => navigate('/')}>
            Voltar para o início
          </button>
        </div>
      </main>

      <Footer />
    </div>
  );
}

export default ConfeccaoCarimbos;